module.exports = __webpack_public_path__ + "static/hero-b30087dabbfe620ebc98c97aa9a07277.svg";